<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader> Générer des étiquettes </CCardHeader>

					<CCardBody>
						<CRow>
							<CCol sm="4">
								<select-printer ref="printer" />
							</CCol>
							<CCol sm="4">
								<CInput
									label="Nombre d'étiquette à imprimer"
									placeholder="(vide=toute)"
									type="number"
									min="1"
									name="printLimit"
									v-model.number="printLimit" />
							</CCol>
						</CRow>
						<CRow>
							<CCol sm="4">
								<vc-date-picker
									mode="date"
									timezone="UTC"
									:masks="{ input: 'DD/MM/YYYY' }"
									v-model="sendingDate">
									<template v-slot="{ inputValue, inputEvents }">
										<CInput
											label="Changer la date d'envoi à l'impression"
											type="text"
											name="sendingDate"
											:value="inputValue"
											v-on="inputEvents" />
									</template>
								</vc-date-picker>
							</CCol>
						</CRow>
						<CButton
							class="mb-3"
							:disabled="pdfLoading"
							@click.prevent="onSubmit('multiple', null)"
							color="success">
							<CSpinner v-show="pdfLoading" color="#fff" size="sm" />
							<span class="ml-2">Imprimer la séléction d'étiquettes</span>
							<CIcon class="ml-2" name="cil-tags" />
						</CButton>
						<GDataTableRemote
							ref="mainTable"
							:remote-url="`/api/order_items?parentOrder.status[]=order.paid&parentOrder.status[]=order.complete&parentOrder.status[]=order.admin_authorized&parentOrder.status[]=order.awaiting_delayed_payment&state=order_item.pending&shippingMethod[]=CHRONO13&shippingMethod[]=INT`"
							:fields="fields"
							:items-per-page="10"
							:default-filter-state="defaultFilterState"
							hover
							striped
							sorter
							columnFilter
							pagination>
							<template #receiverAddress.country-filter>
								<select
									class="form-control form-control-sm"
									@change="
										$refs.mainTable.columnFilterEvent(
											'receiverAddress.country',
											$event.target.value,
											'change'
										)
									">
									<option></option>
									<!-- Placeholder -->
									<option v-for="option in countriesOptions" :value="option.value">
										{{ option.label }}
									</option>
								</select>
							</template>

							<template #product-filter>
								<select
									class="form-control form-control-sm"
									@change="
										$refs.mainTable.columnFilterEvent(
											'product',
											$event.target.value,
											'change'
										)
									">
									<option></option>
									<!-- Placeholder -->
									<!--                                    <option v-for="option in productsOptions" :value="option.value">{{ option.label }}</option>-->
								</select>
							</template>

							<template #product="{ item }">
								<td>
									{{ item.product ? item.product.name : '' }}
								</td>
							</template>

							<template #receiverAddress.country="{ item }">
								<td>
									{{ item.receiverAddress ? item.receiverAddress.country.name : '' }}
								</td>
							</template>

							<template #parentOrder.concept="{ item }">
								<td>
									<CBadge :color="orderConceptColor[item.parentOrder.concept]">{{
										orderConceptTranslation[item.parentOrder.concept]
									}}</CBadge>
								</td>
							</template>

							<template #hasMessage="{ item }">
								<td v-if="item.hasMessage" class="text-center">
									<CIcon name="cil-check" style="color: green" />
								</td>
								<td v-if="!item.hasMessage" class="text-center">
									<CIcon name="cil-ban" style="color: red" />
								</td>
							</template>

							<template #exact_name="{ item }">
								<td>
									{{ item.name }}
								</td>
							</template>

							<template #actions="{ item }">
								<td class="text-center">
									<a
										class="text-center icon-space"
										href="#"
										@click.prevent="onSubmit('single', item.id)">
										<CIcon name="cil-tag" />
									</a>
								</td>
							</template>
						</GDataTableRemote>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
	</div>
</template>
<script>
	import GDataTableRemote from '../../../../components/ghostlexly-components/GDataTableRemote';
	import SelectPrinter from '../../../../components/select-printer';

	export default {
		components: { SelectPrinter, GDataTableRemote },
		data() {
			this.orderConceptOptions = [
				{ value: 'order.colipays', label: 'Colipays' },
				{ value: 'order.colikado', label: 'Colikado' },
				{ value: 'order.aupaysdesfleurs', label: 'Au pays des fleurs' },
			];

			return {
				quantity: null,
				fields: [
					{ key: 'reference', label: '#' },
					{ key: 'parentOrder.id', label: '# Commande' },
					{
						key: 'parentOrder.concept',
						label: 'Concept',
						type: 'select',
						filterSelectOptions: this.orderConceptOptions,
					},
					{
						key: 'exact_name',
						label: 'Type de colis',
						sorter: true,
						type: 'autocomplete',
						queryUrl: '/api/order_items?order[name]=asc',
						searchFieldName: 'name',
					},
					{
						key: 'hasMessage',
						label: 'Message dans le colis?',
						type: 'select',
						filterSelectOptions: [
							{ value: 0, label: 'Non' },
							{ value: 1, label: 'Oui' },
						],
					},
					{ key: 'shippingDate', label: "Date d'envoi", type: 'daterange' },
					{ key: 'receiverAddress.postalCode', label: 'Code postal', sorter: true },
					{ key: 'receiverAddress.country', label: 'Pays' },
					{ key: 'actions', filter: false },
				],
				defaultFilterState: {
					shippingDate: {
						start: this.$moment().format('YYYY-MM-DD'),
						end: this.$moment().format('YYYY-MM-DD'),
					},
				},
				orderConceptTranslation: {
					'order.colipays': 'Colipays',
					'order.colikado': 'Colikado',
					'order.aupaysdesfleurs': 'Au pays des fleurs',
				},
				orderConceptColor: {
					'order.colipays': 'warning',
					'order.colikado': 'danger',
					'order.aupaysdesfleurs': 'success',
				},
				pdfLoading: false,
				countries: [],
				countriesOptions: [],
				printLimit: 1,
				sendingDate: this.$moment().format('YYYY-MM-DD'),
			};
		},
		methods: {
			onSubmit: function (type, id) {
				let error,
					endpoint = null;

				if (!this.$qz.websocket.isActive()) {
					this.$toast.error(
						"Veuillez vous connecter à l'imprimante avant de pouvoir imprimer des étiquettes."
					);
					return false;
				}

				if (type === 'multiple') {
					this.pdfLoading = true;
					let searchQueries = new URLSearchParams();
					searchQueries.append('itemsPerPage', this.printLimit ? this.printLimit : '9999');
					searchQueries.append('parentOrder.status[]', 'order.paid');
					searchQueries.append('parentOrder.status[]', 'order.complete');
					searchQueries.append('parentOrder.status[]', 'order.admin_authorized');
					searchQueries.append('parentOrder.status[]', 'order.awaiting_delayed_payment');
					searchQueries.append('state', 'order_item.pending');

					// Columns search filters
					Object.entries(this.$refs.mainTable.columnFilterState).forEach(([key, value]) => {
						const columnFilter = String(value).toLowerCase();
						if (key === 'shippingDate' && columnFilter) {
							searchQueries.append(
								key + '[after]',
								this.$moment(value.start).format('YYYY-MM-DD HH:mm')
							);
							searchQueries.append(
								key + '[before]',
								this.$moment(value.end).format('YYYY-MM-DD HH:mm')
							);
						} else if (columnFilter && this.$refs.mainTable.rawColumnNames.includes(key)) {
							searchQueries.append(key, columnFilter);
						}
					});

					// Columns orderBy
					searchQueries.append('order[receiverAddress.postalCode]', 'asc');

					// add the new sending date defined by the user
					searchQueries.append(
						'sendingDate',
						this.$moment.utc(this.sendingDate).format('YYYY-MM-DD')
					);

					endpoint = '/api/order_items/labels' + '?' + searchQueries.toString();
					error = 'Aucune étiquettes restante pour ce jour';
				} else {
					endpoint =
						`/api/order_items/${id}/label` +
						'?' +
						`sendingDate=${this.$moment.utc(this.sendingDate).format('YYYY-MM-DD')}`;
					error = 'Colis introuvable ou étiquette déjà imprimée, vérifiez votre référence';
				}

				this.$axios
					.get(endpoint, {
						timeout: 3600000, // 1 hour
					})
					.then(res => {
						this.$refs.printer.send(res.data.zpl).then(o => {
							if (o === true) {
								this.$toast.success("Les étiquettes ont été transmises à l'imprimante.");
							} else {
								this.$toast.error(
									"Un problème est survenu lors de transmission des étiquettes à l'imprimante, veuillez vous rapprocher de l'administrateur pour remettre les étiquettes à disposition"
								);
							}
						});
					})
					.catch(err => {
						if (err.response.status === 404) {
							this.$toast.error(error);
						} else if (err.response.data['hydra:description'] != null) {
							this.$toast.error(err.response.data['hydra:description']);
						} else {
							this.$toast.error(
								'Un problème est survenu lors de la transmission des étiquettes.'
							);
						}
					})
					.finally(() => {
						this.$refs.mainTable.refresh();
						this.pdfLoading = false;
					});
			},
			loadCountries() {
				this.$axios
					.get('/api/countries?itemsPerPage=999')
					.then(res => {
						this.countries = res.data['hydra:member'];
						this.countriesOptions = res.data['hydra:member'].map(country => {
							return {
								value: country['id'],
								label: country.name,
							};
						});
					})
					.catch(err => {
						this.$toast.error(
							'Erreur lors du chargement des pays, veuillez contacter un administrateur'
						);
					});
			},
		},
		mounted() {
			this.loadCountries();
		},
	};
</script>

<style>
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.4s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
</style>
